import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type ColumnsType } from 'antd/es/table';

export interface TableConfigType {
  columns: ColumnsType;
}

export interface ManageActivitiesState {
  isAdvancedSearchOpen: boolean;
  page: number;
  itemsPerPage: number;
  selectedActivityIds: string[];
}

const initialState: ManageActivitiesState = {
  isAdvancedSearchOpen: false,
  page: 1,
  itemsPerPage: 10,
  selectedActivityIds: [],
};

export const manageActivitiesSlice = createSlice({
  name: 'manageActivities',
  initialState,
  reducers: {
    toggleAdvancedSearch: (state) => {
      state.isAdvancedSearchOpen = !state.isAdvancedSearchOpen;
    },
    updateItemsPerPage: (state, action: PayloadAction<number>) => {
      state.itemsPerPage = action.payload;
    },
    updateCurrentPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    resetCurrentPage: (state) => {
      state.page = initialState.page;
    },
    setSelectedActivityIds: (state, action: PayloadAction<string[]>) => {
      state.selectedActivityIds = action.payload;
    },
    resetSelectedActivityIds: (state) => {
      state.selectedActivityIds = initialState.selectedActivityIds;
    },
  },
});

export const {
  toggleAdvancedSearch,
  updateItemsPerPage,
  updateCurrentPage,
  resetCurrentPage,
  setSelectedActivityIds,
  resetSelectedActivityIds,
} = manageActivitiesSlice.actions;

export default manageActivitiesSlice.reducer;
